import type { PatientDetailTabKey } from "@/domains/shared/models/IParentDetail";

const clinicSecretaryAllowedKeys = new Set<string>([
    "agenda.view",
    "agenda.edit",
    "requests.view",
    "requests.edit",
    "chat.view",
    "chat.edit",
    "teamChat.view",
    "teamChat.edit",
    "chatSettings.view",
    "patientTabs.generalView.view",
    "patientTabs.reports.view",
]);

export function clinicSecretaryHasPermission(...path: string[]): boolean {
    return clinicSecretaryAllowedKeys.has(path.join("."));
}

export function clinicSecretaryHasAgendaView(): boolean {
    return clinicSecretaryHasPermission("agenda", "view");
}

export function clinicSecretaryHasAgendaEdit(): boolean {
    return clinicSecretaryHasPermission("agenda", "edit");
}

export function clinicSecretaryHasPatientTabView(tabKey: PatientDetailTabKey): boolean {
    return tabKey === "generalView" || tabKey === "reports";
}

export function clinicSecretaryHasFinanceMenu(): boolean {
    return false;
}

export function clinicSecretaryHasRequestsView(): boolean {
    return clinicSecretaryHasPermission("requests", "view");
}

export function clinicSecretaryHasChatView(): boolean {
    return clinicSecretaryHasPermission("chat", "view");
}

export function clinicSecretaryHasTeamChatView(): boolean {
    return clinicSecretaryHasPermission("teamChat", "view");
}

export function clinicSecretaryHasChatSettingsView(): boolean {
    return clinicSecretaryHasPermission("chatSettings", "view");
}
